import React, {useState, useEffect} from "react";
import {ActivityLogDetails, getUserList} from "../../services/adminServices";
import moment from "moment";
import CustomLoader from "../../CustomComponents/CustomLoader";
import {Autocomplete, TextField, CircularProgress} from "@mui/material";
import {sweetAlertQuestion, sweetAlerts} from "../../utils/sweet-alerts";
import {Skeleton} from "@mui/material";
import {super_admin_role_id} from "../../constant";

const ActivityLog = () => {
	const [firstTimeLoad, setFirstTimeLoad] = useState(true);
	const [activitys, setActivitys] = useState([]);
	const [filteredActivitys, setFilteredActivitys] = useState([]);
	const [loading, setLoading] = useState(true);
	const [searchTerm, setSearchTerm] = useState("");
	const [filterRole, setFilterRole] = useState("all");
	const [filterModel, setFilterModel] = useState("all");
	const role = localStorage.getItem("role");
	const [sortBy, setSortBy] = useState("date-desc");
	const [currentPage, setCurrentPage] = useState(1);
	const [showDetailModal, setShowDetailModal] = useState(false);
	const [selectedLogin, setSelectedLogin] = useState(null);
	const [mockActivitys, setMockActivitys] = useState([]);
	const [loadingButtons, setLoadingButtons] = useState({}); // Track loading state for individual buttons
	const [page, setPage] = useState(1); // Track loading state for individual buttons
	const [pageSize, setPageSize] = useState(10); // Track loading state for individual buttons
	const [totalPages, setTotalPages] = useState(1);
	const [totalLength, setTotalLength] = useState(0);
	const [totalCount, setTotalCount] = useState(0);


	const activitysPerPage = 10;

	const [open, setOpen] = useState(false);
	const [options, setOptions] = useState([]);
	const [loadingUser, setLoadingUser] = useState(true);
	const [debounceTimer, setDebounceTimer] = useState(null);
	const [selectedUserId, setSelectedUserId] = useState(null);

	// Add a new state for the input value
	const [inputValue, setInputValue] = useState("");

	// Fetch addresss data
	const getMockActivitys = async () => {
		const dummyActivityLog = [];

		try {
			if (firstTimeLoad) {
				setLoading(false);
			}
			const response = await ActivityLogDetails({
				pagesize: pageSize,
				page: page,
				userId: selectedUserId,
				sortBy: sortBy,
				action: filterRole,
				model: filterModel,
			});

			if (response && response.status === true && Array.isArray(response?.data?.list) && response?.data?.list?.length > 0) {
				const transformed = response?.data?.list?.map((item) => {
					const addressDate = item.createdAt ? moment(item.createdAt) : null;
					const submittedDate = item.createdAt ? moment(item.createdAt) : null;
					const likes = item?.likes || [];
					const trueCount = likes.filter((likeItem) => likeItem?.like == true).length;

					return {
						id: item.addresses_id,
						fullAddress: item.full_address || "N/A",
						canEdit: !item.is_historic,
						rating: !item.aggregate_rating,
						total_ratings: !item.total_ratings,
						active_ratings: !item.active_ratings,
						issue_summary: !item.issue_summary,
						user_id: !item.user_id,
						manual_id: !item.manual_id,
						flagged: item.admin_flagged || false,
						status: item.is_historic ? "historic" : "fresh",
						userName: item?.user?.first_name + " " + item?.user?.last_name,
						submittedDate: submittedDate ? submittedDate.format("YYYY-MM-DD") : "",
						aggregate_rating: item.aggregate_rating,
						daysAgo: addressDate ? moment().diff(addressDate, "days") : 0,
					};
				});
				setLoading(true);

				setTotalCount(response?.data?.totalCount);
				setMockActivitys(response?.data?.list);
				setTotalLength(response?.data?.totalCount);
				const totalPages = Math.ceil(response?.data?.totalCount / pageSize);
				setTotalPages(totalPages);
			} else {
				setLoading(true);
				// Add dummy data when no API data is available
				setMockActivitys(dummyActivityLog);
			}
		} catch (error) {
			console.error("Error fetching address:", error);
			// Show demo address on error as well
			setMockActivitys(dummyActivityLog);
		}
	};

	const handleSearch = async (query) => {
		if (!query || query.length < 3) {
			setOptions([]);
			return;
		}
		setLoadingUser(true);

		const timer = setTimeout(async () => {
			try {
				const res = await getUserList({search: query});
				setOptions(res?.data);
			} catch (error) {
				console.error("API error:", error);
			} finally {
				setLoadingUser(false);
			}
		}, 300);

		setDebounceTimer(timer);
	};

	useEffect(() => {
		getMockActivitys();
	}, [pageSize, page]);

	useEffect(() => {
		setFilteredActivitys(mockActivitys);
		setLoadingButtons({});
	}, [mockActivitys]);

	// Filter and sort addresss
	useEffect(() => {
		if (firstTimeLoad) {
			setFirstTimeLoad(false);
		} else {
			setPage(1);
			getMockActivitys();
		}
	}, [filterRole, filterModel, sortBy, selectedUserId]);

	const handleViewDetails = (login) => {
		setSelectedLogin(login);
		setShowDetailModal(true);
	};

	const paginate = (pageNumber) => setPage(pageNumber);

	const truncateWords = (text, maxChars) => {
		if (text.length <= maxChars) return text;
		return text.substring(0, maxChars) + "...";
	};

	const getRolesBadge = (role) => {
		if (role == "UPDATE") {
			return <span className="badge badge-warning">Update</span>;
		} else if (role == "SOFT_DELETE") {
			return <span className="badge badge-danger">Delete</span>;
		} else if (role == "CREATE") {
			return <span className="badge badge-success">Create</span>;
		}
		return null;
	};

	const labelMap = {
		activity_log: "Activity",
		addresses: "Addresses",
		feedback: "Feedback",
		likes: "Likes",
		login_log: "Login Log",
		notifications: "Notifications",
		rating: "Rating",
		session: "Session",
		street_comment: "Comments",
		uplift: "Uplift",
		users: "Users",
	};

	const ObjectString = ({recode_data}) => {
		// Handle different data structures
		let changesData = recode_data;

		// If it's a string, try to parse it
		if (typeof recode_data === "string") {
			try {
				changesData = JSON.parse(recode_data);
			} catch (err) {
				changesData = {};
			}
		}

		// Keys to exclude from display
		const excludeKeys = ["sent_by", "user_id", "recode_id", "notification_id", "createdAt", "updatedAt", "recode_data", "old_recode_data", "deleted", "is_read" , "password" , "is_suspended" , "daily_ratings" , "is_contractor" , "is_google_verified" , "auth_otp"];

		// Mapping keys to readable labels
		const labelMap = {
			status: "Status",
			deleted: "Deleted",
			total_ratings: "Total Ratings",
			active_ratings: "Active Ratings",
			aggregate_rating: "Aggregate Rating",
			is_historic: "Is Historic",
			issue_summary: "Issue Summary",
			type: "Type",
			table: "Table",
			title: "Title",
		};

		// Function to format values
		const formatValue = (value) => {
			if (value === null || value === undefined) return "N/A";
			if (typeof value === "boolean") return value ? "Yes" : "No";
			if (typeof value === "object") return JSON.stringify(value);
			return String(value);
		};

		// Function to render change item
		const renderChangeItem = (key, changeData) => {
			// Skip excluded keys
			if (excludeKeys.includes(key)) {
				return null;
			}

			const label = labelMap[key] || key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

			
			if (changeData && typeof changeData === "object" && changeData.hasOwnProperty("to") && changeData.hasOwnProperty("from")) {
				return (
					<div className="change-item" key={key}>
						<div className="change-label">
							<strong>{label}:</strong>
						</div>
						<div className="change-values">
							<div className="change-from">
								<span className="change-label-text">From:</span>
								<span className="change-value from-value">{formatValue(changeData.from)}</span>
							</div>
							<div className="change-to">
								<span className="change-label-text">To:</span>
								<span className="change-value to-value">{formatValue(changeData.to)}</span>
							</div>
						</div>
					</div>
				);
			} else {
				// This is a direct value (for CREATE operations)
				return (
					<div className="change-item" key={key}>
						<div className="change-label">
							<strong>{label}:</strong>
						</div>
						<div className="change-values">
							<div className="change-direct">
								<span className="change-value direct-value">{formatValue(changeData)}</span>
							</div>
						</div>
					</div>
				);
			}
		};

		return (
			<div className="changes-container">
				<h5 className="changes-title">Changes Made:</h5>
				<div className="changes-list">
					{
						Object.entries(changesData)
							.map(([key, value]) => renderChangeItem(key, value))
							.filter((item) => item !== null) // Remove null items (excluded keys)
					}
				</div>
			</div>
		);
	};

	return (
		<div className="admin-ratings-dashboard-page">
			<div className="page-header">
				<h2>Activity Logs</h2>
				<p>View all your login history ({totalLength} total)</p>
			</div>

			{/* Filters and Search */}
			<div className="ratings-controls">
				<div className="filter-section">
					<select className="filter-select" value={filterRole} onChange={(e) => setFilterRole(e.target.value)}>
						<option value="all">All Status</option>
						<option value="create">Create</option>
						<option value="update">Update</option>
						<option value="delete">Delete</option>
					</select>
					<select className="filter-select" value={filterModel} onChange={(e) => setFilterModel(e.target.value)}>
						<option value="all">All Model</option>

						{Object.entries(labelMap).map(([key, value]) => (
							<option key={key} value={key}>
								{value}
							</option>
						))}
					</select>

					<select className="filter-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
						<option value="date-desc">Newest First</option>
						<option value="date-asc">Oldest First</option>
						{/* <option value="address">Address A-Z</option> */}
					</select>

					<Autocomplete
						open={open}
						onOpen={() => setOpen(true)}
						onClose={() => setOpen(false)}
						options={options}
						getOptionLabel={(option) => option?.first_name + " " + option?.last_name || ""}
						loading={loadingUser}
						inputValue={inputValue}
						onInputChange={(e, value, reason) => {
							setInputValue(value);
							handleSearch(value);
							
							// Clear selection when user types or backspaces
							if (reason === 'input') {
								const selectedUser = selectedUserId ? options.find(opt => opt.user_id === selectedUserId) : null;
								const selectedUserName = selectedUser ? `${selectedUser.first_name} ${selectedUser.last_name}` : "";
								
								// If the current input doesn't match the selected user's name, clear selection
								if (value !== selectedUserName) {
									setSelectedUserId(null);
								}
							}
						}}
						onChange={(e, value) => {
							if (value) {
								setSelectedUserId(value.user_id);
								setInputValue(value.first_name + " " + value.last_name);
							} else {
								setSelectedUserId(null);
								setInputValue("");
							}
						}}
						value={selectedUserId ? options.find((opt) => opt.user_id === selectedUserId) || null : null}
						clearIcon={<i className="fa-2xs fas fa-close" />}
						popupIcon={null}
						autoComplete
						includeInputInList
						filterSelectedOptions
						renderInput={(params) => (
							<TextField
								{...params}
								placeholder="User Name"
								sx={{
									"& .MuiOutlinedInput-root": {
										borderRadius: "10px",
										backgroundColor: "#fff",
										"& .MuiOutlinedInput-input": {
											padding: "10px 2px",
											height: 3,
										},
										"& fieldset": {
											borderColor: "#e9ecef",
											borderWidth: "2px",
										},
										"&:hover fieldset": {
											borderColor: "#e9ecef",
											borderWidth: "2px",
										},
										"&.Mui-focused fieldset": {
											borderColor: "#28a745",
											borderWidth: "2px",
											boxShadow: "0 0 0 .2rem #22c55e40",
										},
									},
								}}
								InputProps={{
									...params.InputProps,
									endAdornment: <>{params.InputProps.endAdornment}</>,
								}}
							/>
						)}
						sx={{width: 250}}
					/>
				</div>
			</div>

			{/* Address List */}

			{loading ? (
				<div className="admin-ratings-container">
					{filteredActivitys.length === 0 ? (
						<div className="ratings-table-container">
							<div className="table-responsive sticky-table">
								<table className="ratings-table">
									<thead>
										<tr>
											<th className="align-middle address-cell">User Name</th>
											<th className="align-middle address-cell">Activity Model</th>
											<th className="align-middle address-cell">Activity Type</th>
											<th className="align-middle address-cell">IP Address</th>
											<th className="align-middle address-cell">Activity Time</th>
											<th className="activity-actions-cell text-end">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr className="rating-row">
											<td className="address-cell text-start" colSpan={6}>
												No activitys found
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					) : (
						<div className="ratings-table-container">
							<div className="table-responsive sticky-table">
								<table className="ratings-table">
									<thead>
										<tr>
											<th className="align-middle address-cell">User Name</th>
											<th className="align-middle address-cell">Activity Model</th>
											<th className="align-middle address-cell">Activity Type</th>
											<th className="align-middle address-cell">IP Address</th>
											<th className="align-middle address-cell">Activity Time</th>
											<th className="activity-actions-cell text-end">Actions</th>
										</tr>
									</thead>
									<tbody>
										{filteredActivitys.map((login) => (
											<tr key={login.log_id} className={`comment-row`} data-id={login.log_id}>
												<td className="align-middle address-cell cursor-pointer" title={login?.user?.first_name + " " + login?.user?.last_name} onClick={() => handleViewDetails(login)}>
													{truncateWords(login?.user?.first_name + " " + login?.user?.last_name, 50)}
												</td>
												<td className="align-middle address-cell cursor-pointer" onClick={() => handleViewDetails(login)}>
													{labelMap[login?.model]}
												</td>
												<td className="align-middle address-cell cursor-pointer" onClick={() => handleViewDetails(login)}>
													{getRolesBadge(login?.action)}
												</td>
												<td className="align-middle address-cell cursor-pointer" onClick={() => handleViewDetails(login)}>
													{login?.ip_address}
												</td>
												<td className="align-middle address-cell cursor-pointer" onClick={() => handleViewDetails(login)}>
													{moment(login?.createdAt).format("MMM DD, YYYY HH:MM A")}
												</td>
												<td className="align-middle activity-actions-cell">
													<div className="table-actions mb-0 justify-content-end flex-row">
														<button className="btn-icon" onClick={() => handleViewDetails(login)} title="View Details">
															<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
																<path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" strokeWidth="2" />
																<circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
															</svg>
														</button>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>

							{/* Pagination */}
							<>
								<div className="pagination justify-content-between mt-0 pt-0 pe-3 px-3">
									<div className="pagination-info d-flex justify-content-between align-items-center gap-3">
										<span className="pagination-info-text">
											Showing {page * pageSize - pageSize + 1} to {Math.min(page * pageSize, totalCount)} of {totalCount} entries
										</span>
										<div>
											<select className="filter-select" value={pageSize} onChange={(e) => setPageSize(e.target.value)}>
												<option value="10">10</option>
												<option value="20">20</option>
												<option value="25">25</option>
												<option value="50">50</option>
												<option value="100">100</option>
											</select>
										</div>
									</div>
									<div className="d-flex justify-content-end pb-3 pt-3 pe-2">
										<button className="pagination-btn" onClick={() => paginate(page - 1)} disabled={page === 1}>
											Previous
										</button>

										<div className="pagination-numbers">
											{[...Array(totalPages)].map((_, index) => {
												const ipage = index + 1;
												if (ipage === 1 || ipage === totalPages || (ipage >= page - 1 && ipage <= page + 1)) {
													return (
														<button key={ipage} className={`pagination-number ${page === ipage ? "active" : ""}`} onClick={() => paginate(ipage)}>
															{ipage}
														</button>
													);
												} else if (ipage === page - 2 || ipage === page + 2) {
													return (
														<span key={ipage} className="pagination-ellipsis">
															...
														</span>
													);
												}
												return null;
											})}
										</div>

										<button className="pagination-btn" onClick={() => paginate(page + 1)} disabled={page === totalPages}>
											Next
										</button>
									</div>
								</div>
							</>
						</div>
					)}
				</div>
			) : (
				<div className="ratings-table-container">
					<div className="table-responsive sticky-table">
						<table className="ratings-table">
							<thead>
								<tr>
									<th className="align-middle address-cell">User Name</th>
									<th className="align-middle address-cell">Activity Model</th>
									<th className="align-middle address-cell">Activity Type</th>
									<th className="align-middle address-cell">IP Address</th>
									<th className="align-middle address-cell">Activity Time</th>
									<th className="activity-actions-cell text-end">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr className="rating-row">
									<td className="address-cell text-center" colSpan={6}>
										<CustomLoader />
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			)}

			{/* Detail Modal */}
			{showDetailModal && selectedLogin && (
				<div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
					<div className="modal-content" onClick={(e) => e.stopPropagation()}>
						<div className="modal-header">
							<h3>Information</h3>
							<button className="modal-close" onClick={() => setShowDetailModal(false)}>
								×
							</button>
						</div>

						<div className="modal-body">
							<div className="detail-section">
								<h4>User : {selectedLogin?.user?.first_name + " " + selectedLogin?.user?.last_name}</h4>
								<div className="detail-grid">
									<div className="detail-item">
										<span className="detail-label">Activity Model:</span>
										<span className="detail-value">{selectedLogin?.model}</span>
									</div>
									<div className="detail-item">
										<span className="detail-label">Activity Type</span>
										<span className="detail-value">{getRolesBadge(selectedLogin?.action)}</span>
									</div>

									<div className="detail-item">
										<span className="detail-label">Activity Time:</span>
										<span className="detail-value">{moment(selectedLogin.createdAt).format("MMM DD, YYYY HH:MM A")}</span>
									</div>
									<div className="detail-item">
										<span className="detail-label">IP Address:</span>
										<span className="detail-value">{selectedLogin.ip_address}</span>
									</div>
								</div>

								{selectedLogin.changes && selectedLogin.action !== "SOFT_DELETE" && <div className="notification-details">{ObjectString({recode_data: selectedLogin.changes})}</div>}
							</div>
						</div>

						<div className="modal-footer">
							<button className="btn btn-secondary" onClick={() => setShowDetailModal(false)}>
								Close
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ActivityLog;
